const parseHostPort = (raw: string) => {
  const first = raw.split(",")[0]?.trim() || "";
  const noProto = first.includes("://") ? first.split("://").pop() || "" : first;
  return noProto.split("/")[0] || "";
};

const hostnameOf = (hostPort: string) => (hostPort.split(":")[0] || "").toLowerCase();

export const isLocalDevHost = (hostPort: string) => {
  const hostname = hostnameOf(hostPort);
  return hostname === "localhost" || hostname === "127.0.0.1";
};

export const getFixedCmsDomain = () =>
  process.env.FIX_CMS_DOMAIN?.trim() || process.env.NEXT_PUBLIC_FIX_CMS_DOMAIN?.trim() || "";

/** CMS inquiry domain: on localhost, optional FIX_CMS_DOMAIN overrides the request host. */
export const resolveCmsDomain = (requestHostPort: string) => {
  const hostPort = parseHostPort(requestHostPort);
  const fixed = getFixedCmsDomain();

  if (hostPort) {
    if (isLocalDevHost(hostPort)) {
      if (fixed) return parseHostPort(fixed);
      if (hostPort.includes(":")) return hostPort;
      return `${hostnameOf(hostPort)}:${process.env.APP_PORT || "3101"}`;
    }
    return hostPort;
  }

  const fallback =
    process.env.LOCAL_CMS_DOMAIN?.trim() ||
    (process.env.APP_PORT ? `localhost:${process.env.APP_PORT}` : "localhost:3101");

  if (isLocalDevHost(fallback) && fixed) {
    return parseHostPort(fixed);
  }

  return fallback;
};
